import ZeissButton from '@components/button';
import ZeissModal from '@components/zeiss-modal';
import { Space } from 'antd';
// import './index.scss';
export const FirstNoticePopup = ({ open, handleCancel, handleOk }: any) => {
  return (
    <ZeissModal
      open={open}
      width={520}
      centered
      footer={null}
      onCancel={handleCancel}
    >
      <div className="pc-forwardAnn-layout">
        <div className="pc-forwardAnn-title">请先去处理第一个公告</div>
        <div>确认处理完成后，可查看当前公告。</div>
        <div className="pc-subLayout" style={{ padding: 0 }}>
          <Space className="pc-matter-createAnn-footer" size="middle">
            <ZeissButton className="pc-normal-btn" onClick={handleCancel}>
              取消
            </ZeissButton>
            <ZeissButton
              type="primary"
              className="pc-confirm-btn"
              onClick={handleOk}
            >
              去处理
            </ZeissButton>
          </Space>
        </div>
      </div>
    </ZeissModal>
  );
};
